import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CookieConsent.css';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà accepté/refusé les cookies
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Attendre 1 seconde avant d'afficher la pop-up
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`cookie-consent ${isVisible ? 'visible' : ''}`}>
      <div className="cookie-overlay" onClick={() => setIsVisible(false)}></div>
      
      <div className="cookie-container">
        <div className="cookie-header">
          <span className="cookie-icon">🍪</span>
          <h3 className="cookie-title">
            {t('cookies.title') || 'Cookies & Confidentialité'}
          </h3>
        </div>

        <div className="cookie-content">
          <p className="cookie-description">
            {t('cookies.description') || 
              'Nous utilisons des cookies pour améliorer votre expérience sur notre site. Les cookies essentiels sont nécessaires au fonctionnement du site, tandis que les cookies analytiques nous aident à comprendre comment vous utilisez notre site.'}
          </p>

          {showDetails && (
            <div className="cookie-details">
              <div className="cookie-category">
                <div className="category-header">
                  <strong>🔒 {t('cookies.necessary') || 'Cookies essentiels'}</strong>
                  <span className="category-badge required">
                    {t('cookies.required') || 'Requis'}
                  </span>
                </div>
                <p className="category-description">
                  {t('cookies.necessaryDesc') || 
                    'Ces cookies sont indispensables au fonctionnement du site (authentification, préférences de langue, consentement cookies).'}
                </p>
              </div>

              <div className="cookie-category">
                <div className="category-header">
                  <strong>📊 {t('cookies.analytics') || 'Cookies analytiques'}</strong>
                  <span className="category-badge optional">
                    {t('cookies.optional') || 'Optionnel'}
                  </span>
                </div>
                <p className="category-description">
                  {t('cookies.analyticsDesc') || 
                    'Ces cookies nous aident à comprendre comment vous utilisez notre site pour améliorer votre expérience (Google Analytics, statistiques de visite).'}
                </p>
              </div>
            </div>
          )}

          <button 
            className="cookie-details-toggle"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails 
              ? (t('cookies.hideDetails') || '▲ Masquer les détails') 
              : (t('cookies.showDetails') || '▼ Afficher les détails')}
          </button>
        </div>

        <div className="cookie-actions">
          <button 
            className="cookie-btn reject"
            onClick={handleReject}
          >
            {t('cookies.reject') || 'Tout refuser'}
          </button>
          <button 
            className="cookie-btn necessary"
            onClick={handleAcceptNecessary}
          >
            {t('cookies.necessary') || 'Essentiels seulement'}
          </button>
          <button 
            className="cookie-btn accept"
            onClick={handleAcceptAll}
          >
            {t('cookies.acceptAll') || 'Tout accepter'}
          </button>
        </div>

        <p className="cookie-footer">
          {t('cookies.footer') || 'Vous pouvez modifier vos préférences à tout moment.'}
        </p>
      </div>
    </div>
  );
};

export default CookieConsent;